// extracted by mini-css-extract-plugin
export default {"container":"Map--container--KV1rG","notSupported":"Map--notSupported--0waV-"};